var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 17,
    viewBox: "0 0 39 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.26333,
    cy: 5.97964,
    r: 5.51529,
    fill: "#A5AA9C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.7367,
    cy: 5.97964,
    r: 5.51529,
    fill: "#A5AA9C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.04152 4.83392C7.02883 4.7402 7.01783 4.64829 7.00847 4.55832L8.0031 4.45483C8.18441 6.19747 9.06244 8.80577 11.1035 10.8995C12.8378 12.6784 15.4357 14.1112 19.2317 14.3055L19.2323 14.2948C19.5749 14.3148 19.9092 14.3255 20.2354 14.3275C20.5615 14.3255 20.8958 14.3148 21.2384 14.2948L21.2391 14.3055C25.0351 14.1112 27.6329 12.6784 29.3672 10.8995C31.4083 8.80577 32.2863 6.19747 32.4676 4.45483L33.4623 4.55832C33.4529 4.64828 33.4419 4.74019 33.4292 4.83391L34.3371 4.92837C34.123 6.98605 33.1031 10.0022 30.7355 12.4309C28.5175 14.706 25.1453 16.4355 20.2354 16.4068C15.3256 16.4355 11.9533 14.706 9.7354 12.4309C7.36773 10.0022 6.34782 6.98605 6.13373 4.92837L7.04152 4.83392ZM8.44052 8.96134C8.94298 9.91062 9.60359 10.8631 10.4514 11.7328C12.3112 13.6405 15.0958 15.1751 19.1608 15.3832L19.1615 15.3718C19.5283 15.3932 19.8862 15.4047 20.2354 15.4068C20.5847 15.4047 20.9426 15.3932 21.3094 15.3718L21.3101 15.3832C25.3751 15.1751 28.1597 13.6405 30.0194 11.7328C30.8691 10.8612 31.5308 9.90647 32.0336 8.95514C31.5352 9.86235 30.8933 10.7666 30.0832 11.5975C28.0015 13.7329 24.8377 15.3544 20.2354 15.3275C15.633 15.3544 12.4692 13.7329 10.3875 11.5975C9.57927 10.7685 8.93844 9.86647 8.44052 8.96134Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing);
export default __webpack_public_path__ + "static/media/ring.cf0031c11ac48d44669d404270a85f77.svg";
export { ForwardRef as ReactComponent };